import React, { useState } from 'react';

import usePost from '../hooks/usePost';

import Loading from './loading';
import Error from './error';

import Table from '../components/table';

import iSerial from '../interfaces/Serial';
import { useHistory } from 'react-router-dom';

import BlockIcon from '@material-ui/icons/Block';
import AssessmentIcon from '@material-ui/icons/Assessment';
import RadioButtonUncheckedIcon from '@material-ui/icons/RadioButtonUnchecked';

interface SerialsTableProps {
  data: iSerial[];
}

function updateRebootedSerial(
  serials: iSerial[],
  {
    serial: rowSerial,
    isreboot,
  }: { serial: iSerial['serial']; isreboot: iSerial['isreboot'] }
) {
  const serialIndex = serials.findIndex(
    ({ serial }: iSerial) => serial === rowSerial
  );
  const updatedSerials = [...serials];
  updatedSerials[serialIndex] = {
    ...serials[serialIndex],
    isreboot,
    reboot: isreboot ? 'Rebooted' : 'Not rebooted',
  };
  return updatedSerials;
}

export default function SerialsTable({ data }: SerialsTableProps) {
  const [ser, setSerial] = useState({ serial: '', isreboot: false });

  const history = useHistory();

  const [response, rebootSerial] = usePost({
    path: 'main',
    payload: { btn: 'reboot' },
  });

  function cbRebootSerial(rowData: iSerial) {
    rebootSerial({ serial: rowData.serial, reboot: Number(!rowData.isreboot) });
    setSerial({ ...ser, serial: rowData.serial, isreboot: !rowData.isreboot });
  }

  function setIcon(rowData: iSerial) {
    return rowData.isreboot ? RadioButtonUncheckedIcon : BlockIcon;
  }

  return (
    <>
      <div style={{ maxWidth: '100%' }}>
        <Table
          columns={[
            { title: 'Serial', field: 'serial' },
            { title: 'Email', field: 'email' },
            { title: 'Ip address', field: 'localip' },
            { title: 'Location', field: 'location' },
            { title: 'Product ID', field: 'productid' },
            { title: 'Firmware', field: 'firmware' },
            { title: 'Reboot', field: 'reboot' },
          ]}
          data={response.data ? updateRebootedSerial(data, ser) : data || []}
          title='Serials'
          actions={[
            {
              iconCb: setIcon,
              cb: cbRebootSerial,
              name: 'reboot',
            },
            {
              icon: AssessmentIcon,
              disabled: false,
              tooltip: 'Show report',
              cb: (rowData: iSerial) => {
                history.push('/report', { serial: rowData.serial });
              },
            },
          ]}
        />
      </div>
      <Error error={response.error} />
      <Loading loading={response.isLoading} />
    </>
  );
}
